module.exports = __webpack_public_path__ + "image/solution_icon1.png";